<template>
	<basic-container>
		<div style="color: red">请输入手机号或微信号进行搜索并选择！</div>
		<avue-crud
			v-bind="bindVal"
			v-model="formData"
			v-on="onEvent"
			:page.sync="page"
			@on-load="getList"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange">
			<template slot="menu" slot-scope="{row}">
				<el-button type="text" @click="onCheck(row)">选择</el-button>
			</template>
		</avue-crud>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
import {mapGetters} from 'vuex'

const option = {
	//模块名字
	name: 'clueIdList',
	optionPath: 'channel/channelOption',
	optionNameList: ['clueIdListption'],
	apiPath: 'team/place',
	//接口名字
	apiNameList: ['searchCustomerClue'],
	//接口名字
	apiNameDelList: [''],
	apiNameAddList: [''],
	apiNameUpdateList: [''],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		data() {
			return {
				page: {
					total: 0,
					currentPage: 1,
					pageSize: 10,
					pageSizes: [10, 20, 40, 80, 100, 500, 1000],
				},
			}
		},
		props: ['channel'],
		computed: {
			...mapGetters(['permissions']),
		},
		created() {
			this.isNotFirstInit = false
		},

		methods: {
			//可以重写getList() {},
			//列表前操作方法
			listBefore() {},
			//列表后操作方法
			forMatterListData(data) {
				return data
			},
			dealResponseData(response) {
				console.log('dealResponseData', response)
				let {data, code = 0} = response.data
				if (code == 0 && data && data.length > 0) {
					this.page.total = 1
					this.listData = data
				}
			},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//选择数据
			onCheck(row) {
				this.$confirm(`请确认是否选择该留资客户`, '提示', {
					confirmButtonText: '确定',
				}).then(() => {
					this.$emit('chooseClue', row)
				})
			},
			//额外添加请求参数
			addRequestData() {
				// 处理手机号或微信号搜索逻辑
				let {mobile = '', wxNo = ''} = this.searchParams
				let searchData = {}
				
				// 如果两个字段都有值，优先使用手机号
				if (mobile && mobile.trim()) {
					searchData.mobile = mobile.trim()
				} else if (wxNo && wxNo.trim()) {
					searchData.wxNo = wxNo.trim()
				}
				
				// 清除原始搜索参数，避免重复传递
				this.searchParams.mobile = undefined
				this.searchParams.wxNo = undefined
				
				return searchData
			},
		},
	},
	option,
)
</script>

<style lang="scss" scoped>
::v-deep .avue-form__group {
	overflow: auto;
}
</style>
